import React, { useEffect } from 'react'
import styles from './OrderEntryOverlay.module.scss'
import { Button as TdsButton } from '@instacart/tds'

type OrderEntryOverlayProps = {
  onClose: () => void
  editOrderId?: string | null
}

export const OrderEntryOverlay = ({ onClose, editOrderId }: OrderEntryOverlayProps) => {
  const iframeSrc = editOrderId
    ? `/orderentryapp?editOrderId=${encodeURIComponent(editOrderId)}`
    : '/orderentryapp'

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return
      if (event.data?.type === 'orderEntry:close') onClose()
    }
    window.addEventListener('message', handler)
    return () => window.removeEventListener('message', handler)
  }, [onClose])

  return (
    <div className={styles.overlay}>
      <div className={styles.header}>
        <TdsButton variant="secondary" onClick={onClose}>
          Back to Orders
        </TdsButton>
      </div>
      <iframe src={iframeSrc} title="Order Entry" className={styles.iframe} />
    </div>
  )
}
